import { ContentContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { ClientSubClientFiltersBar } from './subClients/ClientSubClientFiltersBar';
import { ClientSubClientList } from './subClients/ClientSubClientList';

type Props = {
  clientId: string;
};

export function SubClientsTab({ clientId }: Readonly<Props>) {
  const [reloadPage, setReloadPage] = useState(false);
  const [activeOnly, setActiveOnly] = useState<boolean | undefined>(true);

  return (
    <ContentContainer>
      <ClientSubClientFiltersBar
        clientId={clientId}
        onReloadPage={() => setReloadPage(!reloadPage)}
        activeOnly={activeOnly}
        setActiveOnly={setActiveOnly}
      />
      <ClientSubClientList
        clientId={clientId}
        reloadPage={reloadPage}
        activeOnly={activeOnly}
      />
    </ContentContainer>
  );
}
